import Marquee from "react-fast-marquee";

const items = [
  "Stir Up The Mighty Men",
  "Consecrate For War",
  "PeakDwellers 2026",
  "Ascend Together",
];

export const RibbonMarquee = () => (
  <div
    className="border-y border-border bg-background py-6"
    data-testid="ribbon-marquee"
  >
    <Marquee speed={40} gradient={false} autoFill>
      {items.map((t, i) => (
        <span key={i} className="flex items-center">
          <span className="font-editorial italic text-3xl md:text-5xl text-secondary/80 px-16">
            {t}
          </span>
          <span className="text-primary text-2xl">✦</span>
        </span>
      ))}
    </Marquee>
  </div>
);

export default RibbonMarquee;
